@if(!about.idUploadFlow) {
  @if (!isMobileScreen) {
    <nav aria-label="Progress bar">
      <mat-stepper #stepper aria-label="Progress Bar" aria-hidden="true">
        @for (step of enabledSteps; track step) {
          <mat-step  [editable]=false>
            <ng-template
              matStepLabel>{{ step.description }}
            </ng-template >
          </mat-step>
        }
      </mat-stepper>
    </nav>
  }

  @if (isMobileScreen) {
    <nav aria-label="Progress bar">
      <mat-stepper #stepper aria-label="Progress Bar" aria-hidden="true">
        @for (step of enabledSteps; track step) {
          <mat-step  [editable]=false>
          </mat-step>
        }
      </mat-stepper>
    </nav>
    <p i18n class="progress-step-description">Step {{stepIndex +1}} of {{enabledSteps.length}} : {{ currentDescription }}</p>
  }
}
